import React, { isValidElement, useRef } from 'react'
import { AccordionItemType } from '@contracts/acf/accordion'

import * as styles from './IconAccordionItem.module.scss'
import Wysiwyg from '../Wysiwyg/Wysiwyg'
import Image from '../WordPress/Image'

type Props = {
	data: AccordionItemType
	isActive: boolean
	handleSetActive: () => void
}

const IconAccordionItem: React.FC<Props> = ({ data, isActive, handleSetActive }) => {
	const contentRef = useRef<HTMLDivElement>(null)

	return (
		<li className={styles.item}>
			<div className={styles.header} onClick={() => handleSetActive()}>
				<div className={styles.titleContainer}>
					{data.icon ? <Image image={data.icon} altText={data.title} className={styles.icon} /> : null}

					<h3 className={styles.title}>{data.title}</h3>
				</div>

				<span className={styles.toggle}>{isActive ? '-' : '+'}</span>
			</div>

			<div
				className={`${styles.content} ${isActive && styles.active}`}
				style={{
					height: isActive ? `${contentRef.current?.scrollHeight}px` : '0',
				}}
				ref={contentRef}
			>
				{/* @ts-ignore */}
				{isValidElement(data.content) ? data.content : <Wysiwyg data={data.content} />}
			</div>
		</li>
	)
}

export default IconAccordionItem
